import { StyleFillType, InputStyleProperty } from '../enums';
import { StyleColorSchemeType, StyleSizeType } from '../../../styles/enums';

const InputStyleProps = {
  props: {
    [InputStyleProperty.PrependIconType]: {
      default: '',
      type: String,
    },
    [InputStyleProperty.ClassName]: {
      default: '',
      type: String,
    },
    [InputStyleProperty.InputClassName]: {
      default: '',
      type: String,
    },
    [InputStyleProperty.InputLabelClassName]: {
      default: '',
      type: String,
    },
    [InputStyleProperty.IconColor]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [InputStyleProperty.ColorScheme]: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    [InputStyleProperty.IconSize]: {
      default: StyleSizeType.XSmall,
      type: String,
    },
    [InputStyleProperty.LabelColorScheme]: {
      default: StyleColorSchemeType.Primary,
      type: String,
    },
    [InputStyleProperty.AppendIconType]: {
      default: '',
      type: String,
    },
    [InputStyleProperty.FillType]: {
      default: StyleFillType.Underlined,
      type: String,
    },
  },
};

export default InputStyleProps;
